"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _invariant = _interopRequireDefault(require("invariant"));

/* eslint-disable max-classes-per-file */
var MemoryStore = /*#__PURE__*/function () {
  function MemoryStore() {
    (0, _classCallCheck2.default)(this, MemoryStore);
    this.data = undefined;
  }

  (0, _createClass2.default)(MemoryStore, [{
    key: "getItem",
    value: function getItem()
    /* key */
    {
      return this.data;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this.data = value;
    }
  }, {
    key: "removeItem",
    value: function removeItem()
    /* key */
    {
      this.data = undefined;
    }
  }]);
  return MemoryStore;
}();
/**
 * Trida
 */


var ClientClass = function ClientClass(_ref) {
  var _this = this;

  var accessToken = _ref.accessToken,
      callOptions = _ref.callOptions,
      clientCode = _ref.clientCode,
      hostUri = _ref.hostUri,
      idField = _ref.idField,
      secureClientId = _ref.secureClientId,
      tokenStorage = _ref.tokenStorage;
  (0, _classCallCheck2.default)(this, ClientClass);
  this.connect = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            throw new Error('ClientClass please implement method `connect` in child class.');

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  this.extractId = function (data) {
    return typeof data === 'string' ? data : data[_this.idField];
  };

  this.thisStorageKey = function () {
    return ClientClass.storageKey(_this.clientCode);
  };

  this.getAccessTokenSync = function () {
    return _this.storage.getItem(_this.thisStorageKey());
  };

  this.getAccessToken = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _this.getAccessTokenSync());

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  this.setAccessToken = function (token) {
    return _this.storage.setItem(_this.thisStorageKey(), token);
  };

  this.removeAccessToken = function () {
    return _this.storage.removeItem(_this.thisStorageKey());
  };

  this.getClient = function () {
    (0, _invariant.default)(_this.app, 'Client is not initialized');
    return _this.app;
  };

  this.call = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(serviceName, data, cfg) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              (0, _invariant.default)(false, "Client 'call' method is not implemented.");

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.list = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(serviceName, params, cfg) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              (0, _invariant.default)(false, "Client 'list' method is not implemented.");

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4, _x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.get = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(serviceName, idOrData, cfg) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              (0, _invariant.default)(false, "Client 'get' method is not implemented.");

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x7, _x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.create = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(serviceName, data, cfg) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              (0, _invariant.default)(false, "Client 'create' method is not implemented.");

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x10, _x11, _x12) {
      return _ref7.apply(this, arguments);
    };
  }();

  this.update = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(serviceName, data, cfg) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              (0, _invariant.default)(false, "Client 'update' method is not implemented.");

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x13, _x14, _x15) {
      return _ref8.apply(this, arguments);
    };
  }();

  this.remove = /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(serviceName, idOrData, cfg) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              (0, _invariant.default)(false, "Client 'remove' method is not implemented.");

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x16, _x17, _x18) {
      return _ref9.apply(this, arguments);
    };
  }();

  this.addEventListener = function (eventName, handler) {};

  this.removeEventListener = function (eventName, handler) {};

  if (tokenStorage === 'localStorage' && window && window.localStorage) {
    this.store = window.localStorage;
  } else if (tokenStorage && typeof tokenStorage === 'function') {
    this.storage = tokenStorage();
  } else {
    this.storage = new MemoryStore();
  }

  this.setAccessToken(accessToken);
  this.globalCallOptions = callOptions || {};
  this.hostUri = hostUri || 'http://localhost:3030';
  this.clientCode = clientCode;
  this.app = undefined;
  this.idField = idField || 'id';
  this.secureClientId = secureClientId || '';
}
/**
 * @abstract
 */
;

exports.default = ClientClass;

ClientClass.storageKey = function (clientCode) {
  return "".concat(clientCode).concat(clientCode ? '' : 'application', "-access-token");
};